import React, { useState, memo } from 'react';
import PageHeader from '../components/PageHeader';
import PackageCard from '../components/PackageCard';
import { Search, Calendar, Users, DollarSign } from 'lucide-react';
const Umrah = () => {
  const [selectedMonth, setSelectedMonth] = useState('');
  const [selectedGroupSize, setSelectedGroupSize] = useState('');
  const [selectedBudget, setSelectedBudget] = useState('');
  const packages = [{
    id: 'umrah-1',
    title: 'Classic Umrah Package',
    image: 'https://images.unsplash.com/photo-1591221668516-0d6c8c7eb11b?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80',
    duration: '12 Days',
    groupSize: '25-30 People',
    location: 'Makkah & Madinah',
    startDate: 'Monthly Departures',
    price: 4999,
    description: 'Our most popular Umrah package includes 5-star accommodations, experienced guides, and comprehensive spiritual support.',
    featured: true
  }, {
    id: 'umrah-2',
    title: 'Premium Umrah Experience',
    image: 'https://images.unsplash.com/photo-1591221665710-c6a7dd645673?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80',
    duration: '15 Days',
    groupSize: '15-20 People',
    location: 'Makkah & Madinah',
    startDate: 'Weekly Departures',
    price: 6999,
    description: 'Luxury accommodations and personalized service for a truly memorable Umrah experience.'
  }, {
    id: 'umrah-3',
    title: 'Family Umrah Package',
    image: 'https://images.unsplash.com/photo-1591221669919-c2fb37a42832?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80',
    duration: '10 Days',
    groupSize: 'Family Groups',
    location: 'Makkah & Madinah',
    startDate: 'Flexible Dates',
    price: 3999,
    description: 'Special package designed for families, with child-friendly accommodations and services.'
  }
  // Add more packages as needed
  ];
  return <div className="w-full" data-id="element-1213">
      <PageHeader title="Umrah Packages" subtitle="Embark on a spiritual journey with our comprehensive Umrah packages" backgroundImage="https://images.unsplash.com/photo-1591221665708-bc8c5b156fe2?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80" data-id="element-1214" />
      {/* Filter Section */}
      <section className="py-8 bg-navy-50" data-id="element-1215">
        <div className="container mx-auto px-4 md:px-8" data-id="element-1216">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-1217">
            <div data-id="element-1218">
              <label className="block text-sm font-medium text-navy-900 mb-2" data-id="element-1219">
                Month of Travel
              </label>
              <select value={selectedMonth} onChange={e => setSelectedMonth(e.target.value)} className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-500" data-id="element-1220">
                <option value="" data-id="element-1221">Any Month</option>
                <option value="jan" data-id="element-1222">January</option>
                <option value="feb" data-id="element-1223">February</option>
                {/* Add more months */}
              </select>
            </div>
            <div data-id="element-1224">
              <label className="block text-sm font-medium text-navy-900 mb-2" data-id="element-1225">
                Group Size
              </label>
              <select value={selectedGroupSize} onChange={e => setSelectedGroupSize(e.target.value)} className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-500" data-id="element-1226">
                <option value="" data-id="element-1227">Any Size</option>
                <option value="small" data-id="element-1228">Small (15-20)</option>
                <option value="medium" data-id="element-1229">Medium (20-25)</option>
                <option value="large" data-id="element-1230">Large (25-30)</option>
              </select>
            </div>
            <div data-id="element-1231">
              <label className="block text-sm font-medium text-navy-900 mb-2" data-id="element-1232">
                Budget Range
              </label>
              <select value={selectedBudget} onChange={e => setSelectedBudget(e.target.value)} className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-500" data-id="element-1233">
                <option value="" data-id="element-1234">Any Budget</option>
                <option value="economy" data-id="element-1235">Economy ($3000-$4000)</option>
                <option value="standard" data-id="element-1236">Standard ($4000-$5000)</option>
                <option value="premium" data-id="element-1237">Premium ($5000+)</option>
              </select>
            </div>
            <div className="flex items-end" data-id="element-1238">
              <button className="w-full bg-navy-900 hover:bg-navy-800 text-white p-3 rounded-md font-medium transition-colors flex items-center justify-center" data-id="element-1239">
                <Search size={20} className="mr-2" data-id="element-1240" />
                Search Packages
              </button>
            </div>
          </div>
        </div>
      </section>
      {/* Packages Grid */}
      <section className="py-16 bg-white" data-id="element-1241">
        <div className="container mx-auto px-4 md:px-8" data-id="element-1242">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1243">
            {packages.map(pkg => <PackageCard key={pkg.id} {...pkg} data-id="element-1244" />)}
          </div>
        </div>
      </section>
      {/* Why Choose Us */}
      <section className="py-16 bg-navy-900 text-white" data-id="element-1245">
        <div className="container mx-auto px-4 md:px-8" data-id="element-1246">
          <h2 className="text-3xl font-bold text-center mb-12" data-id="element-1247">
            Why Choose Our Umrah Packages?
          </h2>
          <div className="grid md:grid-cols-3 gap-8" data-id="element-1248">
            <div className="text-center" data-id="element-1249">
              <div className="bg-navy-800 p-6 rounded-lg" data-id="element-1250">
                <h3 className="text-xl font-bold mb-4" data-id="element-1251">Experienced Guides</h3>
                <p className="text-gray-300" data-id="element-1252">
                  Our guides are well-versed in both the spiritual aspects and
                  practical procedures of Umrah.
                </p>
              </div>
            </div>
            <div className="text-center" data-id="element-1253">
              <div className="bg-navy-800 p-6 rounded-lg" data-id="element-1254">
                <h3 className="text-xl font-bold mb-4" data-id="element-1255">
                  Quality Accommodations
                </h3>
                <p className="text-gray-300" data-id="element-1256">
                  Stay in comfortable hotels close to the holy sites for your
                  convenience.
                </p>
              </div>
            </div>
            <div className="text-center" data-id="element-1257">
              <div className="bg-navy-800 p-6 rounded-lg" data-id="element-1258">
                <h3 className="text-xl font-bold mb-4" data-id="element-1259">24/7 Support</h3>
                <p className="text-gray-300" data-id="element-1260">
                  Our team is always available to assist you throughout your
                  spiritual journey.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
};
export default Umrah;